import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { Grid, Row, Col } from "react-flexbox-grid";
import { ExperienceType, AddExpRoute } from "../../../models/enums";
import Paper from "material-ui/Paper";
import FloatingAddBtn from "../../widgets/addBtn"; 
import ProfileStore from "../../../stores/profileStore";
import { CCLCExperience } from "../../../models/profile";
import Tooltip from 'material-ui/Tooltip';
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import * as s from "./credentials.css";

@observer
class DeleteCredentialDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (!this.props.store.profileStore.delExperience) {
      return null;
    }
    const msg: string = `${this.props.store.localization.fields.delRsrcDlg.question1} ${this.props.store.profileStore.delExperience.name} ${this.props.store.localization.fields.delRsrcDlg.question2}`;
    return (<Dialog
      fullScreen={false}
      open={true}
      onClose={this.props.store.profileStore.clearDeleteExperience}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{this.props.store.localization.fields.delRsrcDlg.title}</DialogTitle>
      <DialogContent>
        {msg}
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.store.profileStore.clearDeleteExperience} color="secondary">{this.props.store.localization.fields.cancel}</Button>
        <Button onClick={this.props.store.profileStore.deleteExperience} color="secondary">{this.props.store.localization.fields.delete}</Button>
      </DialogActions>
    </Dialog>);
  }
}

@observer
export default class CredentialSummary extends React.Component<{ store: SeekerStore}, {}> {
  constructor(props: any) {
    super(props);
  }

  @action update = (id: string): void => {
    this.props.store.profileStore.setAddExpRoute(AddExpRoute.Cclc);
    hashHistory.push(`/profile/edit-experience/${id}`);
  }

  renderActionButtons = (expId: string, expType: ExperienceType, title: string): JSX.Element => {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div>
      <a className={s.linkText} onClick={() => this.update(expId)} >{local.editCCLC.update.toLowerCase()}</a>
      &nbsp;|&nbsp;
      <a className={s.linkText} onClick={() => this.props.store.profileStore.setDeleteExperience(expId, expType, title)}>{local.delete.toLowerCase()}</a>
    </div>);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const cclcRows: JSX.Element[] = [];
    const cclc: Array<CCLCExperience> = this.props.store.profileStore.profile.cclcs;  

    cclc.map((c: CCLCExperience, i: number): void => {
      let expired: boolean = c.expired;
      if (c.idHash != null) {
        cclcRows.push(
          <Row key={c.idHash}>
            <Col xs={12}>
              <Row>
                <Col xs={6}>
                  <p className={s.credential}>{c.title}</p>
                </Col>
                <Col xs={4}>
                  {this.renderActionButtons(c.idHash, ExperienceType.CCLC, c.title)}
                </Col>
                <Col xs={2}>
                  {expired && <Tooltip id="tooltip-expired" title={c.title + " is expired"}><img className={s.expiredIcon} src={local.icons.expired} /></Tooltip>}
                </Col>
              </Row>
            </Col>
          </Row>);
      } 
    })

    if (cclcRows.length === 0) {
      cclcRows.push(<p key="no-cred-text">{local.editCCLC.credDefaultMsg}</p>);
    }
   
    return (<Paper elevation={1} className={s.box} >
        <Row className={s.container}>    
        <Col xs={12}>
          <h5 className={s.blueHeader}>{local.editCCLC.credentialHeader}</h5>
          </Col>
          <Row>
            <Col xs={12}>
              {cclcRows}
            </Col>
          </Row>
        </Row>
        <FloatingAddBtn store={this.props.store} value={ExperienceType.CCLC} n={0} />
        <DeleteCredentialDlg store={this.props.store} />
    </Paper>);
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/credentialSummary/index.tsx